export default __webpack_public_path__ + "static/media/adminReport.e38c6aaf.png";